// import * as actionType from '../../views/FileExplorer/store/actions/actionTypes';
import { getData, postData } from 'src/api/http.service';
import { getSubjectById, uploadFiles, uploadPreviewFiles } from 'src/api/subjectsApi';
import { getDataFromSessionStorage, getAPIEndpoints } from 'src/utils';
import { handleApiError, handleApiSuccess } from 'src/utils/general.utils';
import { ApiCallFailedAction, ApiCallInProgress, ApiCallSuccessAction } from './uistate.action';

export const ADD_FILE = 'ADD_FILE';
export const UPDATE_PROGRESS = 'UPDATE_PROGRESS';
export const UPDATE_UPLOADEDTOS3_STATUS = 'UPDATE_UPLOADEDTOS3_STATUS';
export const UPDATE_UPLOADEDTODB_STATUS = 'UPDATE_UPLOADEDTODB_STATUS';
export const UPDATE_UPLOAD_CANCELLED_STATUS = 'UPDATE_UPLOAD_CANCELLED_STATUS';
export const UPDATE_DB = 'UPDATE_DB';

export const ON_CLEAR = 'ON_CLEAR';
export const ALL_CLEAR = 'ALL_CLEAR';
export const CLEAR_UPLOADED = 'CLEAR_UPLOADED';
export const UPDATE_CURRENT_STATE = 'UPDATE_CURRENT_STATE';
export const RESET_FILEEXPLORER_STORE = 'RESET_FILEEXPLORER_STORE';
export const RESET_CURRENT_STATE = 'RESET_CURRENT_STATE';
export const UPDATE_CURRENT_SUBJECT = 'UPDATE_CURRENT_SUBJECT';
export const UPDATE_CURRENT_LIST = 'UPDATE_CURRENT_LIST';
export const APPEND_CURRENT_LIST = 'APPEND_CURRENT_LIST';
// [Hotfix: SP]
export const CURRENT_STATE = 'CACHING CURRENT STATE';
export const GET_ALL_SUBJECTS = 'GET_ALL_SUBJECTS';
export const GET_SUBJECT_BY_ID = 'GET_SUBJECT_BY_ID';
export const UPDATE_INQUEUE_STATUS = 'UPDATE_INQUEUE_STATUS';

// Live Class Recording Types
export const GET_ALL_LIVE_CLASS_RECORDINGS = 'GET_ALL_LIVE_CLASS_RECORDINGS';
export const UPLOAD_LIVE_CLASS_RECORDING = 'GET_ALL_LIVE_CLASS_RECORDINGS';

const actionType = {
  ADD_FILE,
  UPDATE_PROGRESS,
  UPDATE_UPLOADEDTOS3_STATUS,
  UPDATE_UPLOADEDTODB_STATUS,
  UPDATE_UPLOAD_CANCELLED_STATUS,
  UPDATE_DB,
  RESET_FILEEXPLORER_STORE,
  RESET_CURRENT_STATE,
  ON_CLEAR,
  ALL_CLEAR,
  CLEAR_UPLOADED,
  UPDATE_CURRENT_STATE,
  UPDATE_CURRENT_SUBJECT,
  UPDATE_CURRENT_LIST,
  APPEND_CURRENT_LIST,
  // [Hotfix: SP]
  CURRENT_STATE,
  GET_ALL_SUBJECTS,
  GET_SUBJECT_BY_ID,
  UPDATE_INQUEUE_STATUS,
  GET_ALL_LIVE_CLASS_RECORDINGS,
  UPLOAD_LIVE_CLASS_RECORDING,
};

/* Async Action */
export const updateFileToDb = (file, currentStateSnapshot) => async (dispatch, getState) => {
  // Get Store State
  const state = getState();
  const filesList = state.fileExplorerReducer.files;
  const currentState = currentStateSnapshot;

  // Find current file from Files List( State)
  const index = filesList.findIndex(item => item.uuid === file.uuid);
  const currentFile = filesList[index];

  if (currentFile && currentFile.cancelled === false) {
    dispatch(
      updateFileUploadedToS3({
        uuid: file.uuid,
        uploadedToS3Status: true,
      })
    );

    let bodyData;
    try {
      if (currentState.isSubjectsFolder) {
        // [Hotfix: SP]
        bodyData = {
          subjectId: `${currentState.subjectId}`, // [Hotfix: SP]
          unitId: `${currentState.unitId}`, // [Hotfix: SP]
          topicId: `${currentState.topicId}`, // [Hotfix: SP]
          uploadFilesDtoList: [
            {
              file: `${file.fileName}`,
              size: `${file.fileData.size}`,
              awsKey: `subjects/${currentState.subjectId}/${file.uuid}-${file.fileName}`, // [Hotfix: SP]
              videoDurationInSecond: file.videoDurationInSecond,
            },
          ],
          uploadedBy: getDataFromSessionStorage('userInfo').userName,
        };
        await uploadFiles(bodyData);
        const subjectData = await getSubjectById(currentState.subjectId, dispatch);
        if (state.fileExplorerReducer.currentState.isSubjectsFolder) {
          dispatch(updateCurrentSubject(subjectData));
        }
        if (state.fileExplorerReducer.currentState.viewType === 'Files') {
          dispatch(
            GetVideoFromTopicsWithRedux(getAPIEndpoints().getVideosFromTopics, currentState)
          );
        } else {
          updateCurrentListAfterUpload(
            state.fileExplorerReducer.currentState,
            subjectData,
            dispatch
          );
        }
      } else {
        bodyData = {
          catalogueId: `${currentState.unitId}`,
          fileList: [
            {
              file: `${file.fileName}`,
              size: `${file.fileData.size}`,
              awsKey: `preview-videos/${currentState.unitId}/${file.uuid}-${file.fileName}`,
              videoDurationInSecond: file.videoDurationInSecond,
              catalogueId: `${currentState.unitId}`,
            },
          ],
          uploadedBy: getDataFromSessionStorage('userInfo').userName,
        };

        await uploadPreviewFiles(bodyData);
        if (state.fileExplorerReducer.currentState.viewType === 'Files') {
          dispatch(
            GetPreviewVideosListWithRedux(
              getAPIEndpoints().getPreviewVideosList.replace('{id}', `${currentState.unitId}`)
            )
          );
        }
      }
      dispatch(
        updateFileUploadedToDb({
          uuid: file.uuid,
          uploadedToDbStatus: true,
        })
      );
    } catch (error) {
      dispatch(
        updateFileUploadedToDb({
          uuid: file.uuid,
          uploadedToDbStatus: false,
        })
      );
    }
  }
};

/* Async Action */
export const GetAllSubjects = (url, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(url, headers);
    dispatch(GetAllSubjectsSuccessAction(response.data));
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};

export const GetAllLiveClassRecording = (url, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(url, headers);
    dispatch(GetAllLiveClassRecordingAccessAction(response.data));
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};

export const GetSubjectById = (url, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(url, headers);
    // dispatch( GetSubjectByIdSuccessAction( response.data ) );
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};

export const GetVideoFromTopics = (url, body, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await postData(url, body, headers);
    // dispatch( GetSubjectByIdSuccessAction( response.data ) );
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};
//To get the curent video list update to redux state
export const GetVideoFromTopicsWithRedux = (url, body, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await postData(url, body, headers);
    let fileDataTemp =
      response.data &&
      response.data.map(item => {
        return {
          Name: item.file,
          Id: item.awsKey,
          Length: item.size,
          videoDurationInSecond: item.videoDurationInSecond,
          transcodingStatus: item.transcodingStatus,
          catalogueId: item.catalogueId,
          videoId: item.videoId,
          subjectId: item.subjectId,
          jobId: item.jobId,
          uploadedBy: item.uploadedBy,
          uploadedAt: item.uploadedAt,
        };
      });
    dispatch(updateCurrentList(fileDataTemp));
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};
export const GetPreviewVideosCatalogue = (url, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(url, headers);
    // dispatch( GetSubjectByIdSuccessAction( response.data ) );
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};

export const GetPreviewVideosList = (url, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(url, headers);
    // dispatch( GetSubjectByIdSuccessAction( response.data ) );
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
    return response.data;
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};

export const GetPreviewVideosListWithRedux = (url, headers, metaData) => async dispatch => {
  try {
    dispatch(ApiCallInProgress());
    const response = await getData(url, headers);
    let fileDataTemp =
      response.data &&
      response.data.fileList &&
      response.data.fileList.map(item => {
        return {
          Name: item.file,
          Id: item.awsKey,
          Length: item.size,
          videoDurationInSecond: item.videoDurationInSecond,
          transcodingStatus: item.transcodingStatus,
          catalogueId: item.catalogueId,
          videoId: item.videoId,
          subjectId: item.subjectId,
          jobId: item.jobId,
          uploadedBy: item.uploadedBy,
          uploadedAt: item.uploadedAt,
        };
      });
    dispatch(updateCurrentList(fileDataTemp));
    dispatch(ApiCallSuccessAction(handleApiSuccess(response, metaData)));
  } catch (err) {
    dispatch(ApiCallFailedAction(handleApiError(err, metaData)));
    return false;
  }
};
export const UpdateFileInqueueAction = data => async dispatch => {
  try {
    await dispatch(updateFileInQueue(data));
    return true;
  } catch (err) {
    return false;
  }
};

export const UpdateFileCancelAction = data => async dispatch => {
  try {
    await dispatch(updateFileUploadCanceledStatus(data));
    return true;
  } catch (err) {
    return false;
  }
};
const updateCurrentListAfterUpload = (currentState, rawEachSubject, dispatch) => {
  if (currentState.viewType === 'Topics') {
    const currentUnit = [...rawEachSubject.fileExplorerUnitList].find(
      unit => unit.unitName === currentState.unit
    );
    let topicDataTemp = [...currentUnit.fileExplorerTopicList].map(item => {
      return {
        Name: item.topicName,
        Id: item.topicId,
        Length: item.fileExplorerFolderList[1].awsFileList.length,
        Child: item.fileExplorerFolderList,
      };
    });
    dispatch(updateCurrentList(topicDataTemp));
  }
};
/* Sync Action */
export const addFile = data => ({
  type: actionType.ADD_FILE,
  data,
});

export const updateFile = data => ({
  type: actionType.UPDATE_PROGRESS,
  data,
});

export const updateFileInQueue = data => ({
  type: actionType.UPDATE_INQUEUE_STATUS,
  data,
});

export const updateFileUploadedToDb = data => ({
  type: actionType.UPDATE_UPLOADEDTODB_STATUS,
  data,
});

export const updateFileUploadedToS3 = data => ({
  type: actionType.UPDATE_UPLOADEDTOS3_STATUS,
  data,
});

export const updateFileUploadCanceledStatus = data => ({
  type: actionType.UPDATE_UPLOAD_CANCELLED_STATUS,
  data,
});

export const onClear = uuid =>
  // console.log('Clear:', fileName);
  ({
    type: actionType.ON_CLEAR,
    data: uuid,
  });
export const allClear = () => ({
  type: actionType.ALL_CLEAR,
});

export const clearUploaded = () => ({
  type: actionType.CLEAR_UPLOADED,
});

export const updateCurrentState = currentPage => ({
  type: actionType.UPDATE_CURRENT_STATE,
  data: currentPage,
});

export const resetFileExplorerStore = () => ({
  type: actionType.RESET_FILEEXPLORER_STORE,
});

export const resetCurrentState = () => ({
  type: actionType.RESET_CURRENT_STATE,
});

export const updateCurrentSubject = currentSubject => ({
  type: actionType.UPDATE_CURRENT_SUBJECT,
  data: currentSubject,
});
export const updateCurrentList = currentList => ({
  type: actionType.UPDATE_CURRENT_LIST,
  data: currentList,
});
export const appendCurrentList = newItems => ({
  type: actionType.APPEND_CURRENT_LIST,
  data: newItems,
});

export const GetAllSubjectsSuccessAction = allSubjects => ({
  type: actionType.GET_ALL_SUBJECTS,
  data: allSubjects,
});

export const GetSubjectByIdSuccessAction = subjectData => ({
  type: actionType.GET_SUBJECT_BY_ID,
  data: subjectData,
});

export const GetAllLiveClassRecordingAccessAction = liveClassRecordingData => ({
  type: actionType.GET_ALL_LIVE_CLASS_RECORDINGS,
  data: liveClassRecordingData,
});
